import styled from 'styled-components';
import { theme } from 'themes';

interface Props {
  maxWidth?: number;
}

const maxWidth = (props: Props) =>
  props.maxWidth
    ? { maxWidth: `${props.maxWidth}px` }
    : { maxWidth: props.theme.maxContainerWidth };

const Container = styled.div`
  margin-left: auto;
  margin-right: auto;
  ${maxWidth};
`;

Container.defaultProps = {
  theme: theme,
};

Container.displayName = 'Container';

export default Container;
